import React from 'react'

const FeedbackIcon = (
  <>
    <path
      d="M23.3751 32.5C23.1886 32.5 23.0021 32.4478 22.838 32.3438L0.837996 18.3438C0.534286 18.1504 0.357526 17.8081 0.376086 17.4482C0.394636 17.0889 0.605576 16.7666 0.927846 16.6055L23.3751 2.5L45.8224 16.6055C46.1446 16.7666 46.3556 17.0889 46.3741 17.4482C46.3927 17.8081 46.2159 18.1504 45.9122 18.3438L23.9122 32.3438C23.7482 32.4478 23.5616 32.5 23.3751 32.5Z"
      fill="#76B5B5"
    />
    <path
      d="M23.375 18.1826L22.7373 17.6553C21.8818 16.9478 14.375 10.6055 14.375 5.96143C14.375 2.89893 16.706 0.5 19.6826 0.5C21.0928 0.5 22.4014 1.02148 23.375 1.93652C24.3486 1.02148 25.6572 0.5 27.0674 0.5C30.044 0.5 32.375 2.89893 32.375 5.96143C32.375 10.6055 24.8682 16.9478 24.0127 17.6553L23.375 18.1826Z"
      fill="#E86C60"
    />
    <path
      d="M45.375 42.5C45.291 42.5 45.206 42.4893 45.123 42.4678L22.123 36.4678L22.375 29.5L46.375 17.5V41.5C46.375 41.8096 46.2314 42.1021 45.9863 42.2915C45.8096 42.4282 45.5937 42.5 45.375 42.5Z"
      fill="#9BCED3"
    />
    <path
      d="M45.375 42.5H1.375C0.82227 42.5 0.375 42.0522 0.375 41.5V17.5L45.8535 40.6221C46.2549 40.8408 46.457 41.3042 46.3438 41.7471C46.2314 42.1899 45.832 42.5 45.375 42.5Z"
      fill="#BFDEE0"
    />
  </>
)

export default FeedbackIcon
